import React, { useEffect, useState } from "react";
import axios from "axios";
import "../Styles/style.css";
import { Link } from "react-router-dom";
import { awsImageURL, baseUrl } from "../../api/ipconfig";
import Skeleton from "@mui/material/Skeleton";
import Pagination from "@mui/material/Pagination";

export default function CarDealers() {
  const token = localStorage.getItem("token");
  const [dealerList, setDealerList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusId] = useState(1);

  const fetchData = async () => {
    if (!currentPage) return;
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const { data } = await axios.get(`${baseUrl}/limiteddealerslist`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          status_id: statusId,
          page: currentPage,
          search_name: searchTerm.trim(),
        },
      });
      setDealerList(data?.data?.data || []);
      setTotalPages(data?.data?.last_page || 1);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [currentPage]);

  const handleSearch = () => {
    setCurrentPage(1);
    fetchData();
  };

  const handleClear = async () => {
    setSearchTerm("");
    setCurrentPage(1);
    try {
      const { data } = await axios.get(`${baseUrl}/limiteddealerslist`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          status_id: statusId,
          page: 1,
          search_name: "",
        },
      });
      setDealerList(data?.data?.data || []);
      setTotalPages(data?.data?.last_page || 1);
    } catch (error) {
      console.error("Error clearing search:", error);
    }
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  return (
    <>
      <div className="colorBg_new d-none d-lg-block"></div>
      <div className="container">
        <h2 className="fw-bolder my-4 fs-4">
          Used Car Trader & Dealers in Pakistan
        </h2>

        <div className="mb-4">
          <div className="input-group">
            <input
              type="text"
              className="form-control"
              placeholder="Search Dealers..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <button
              className="btn color-white bgSecondary"
              onClick={handleSearch}
            >
              Search
            </button>
            <button
              className="btn btn-secondary ms-2"
              onClick={handleClear}
              disabled={!searchTerm.trim()}
            >
              Clear
            </button>
          </div>
        </div>

        {loading ? (
          <div className="No_ads_loading p-3 text-center">
            <div className="row">
              {[...Array(4)].map((_, index) => (
                <div key={index} className="col-lg-6 col-md-6 mb-4">
                  <div className="row">
                    <div className="col-lg-4">
                      <Skeleton
                        animation="wave"
                        variant="rounded"
                        width="100%"
                        height={170}
                      />
                    </div>
                    <div className="col-lg-8 d-flex flex-column justify-content-between">
                      <Skeleton
                        animation="wave"
                        variant="rounded"
                        width={300}
                        height={20}
                        className="mb-3"
                      />
                      <Skeleton
                        animation="wave"
                        variant="rounded"
                        width={140}
                        height={17}
                        className="mb-2"
                      />
                      <Skeleton
                        animation="wave"
                        variant="rounded"
                        width={250}
                        height={20}
                        className="mb-2"
                      />
                      <Skeleton
                        animation="wave"
                        variant="rounded"
                        width={180}
                        height={18}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : dealerList.length ? (
          <div className="row mx-0">
            {dealerList.map((item) => (
              <div
                key={item?.showroom_id}
                className="col-lg-6 col-md-6 col-12 mb-4"
              >
                <Link to={`/dealer/${item?.showroom_id}`}>
                  <div className="row pe-3 py-3 myAd card_bg me-md-3">
                    <div className="col-lg-4 Myads_photos cursorPointer">
                      <img
                        src={`${awsImageURL}/dealer/${item?.showroom_id}/${item?.showroom_logo}`}
                        alt={item?.showroom_name || "Dealer Logo"}
                        className="img-fluid h-100 rounded"
                        onError={(e) => {
                          e.target.src =
                            "https://gallery.famewheels.com/appgallery/no-image.png";
                        }}
                      />
                    </div>
                    <div className="col-lg-8 d-flex">
                      <div className="vehicleDetails p-3 rounded-3 bg-white w-100 text-capitalize">
                        <h4 className="fw-600 cursorPointer">
                          {item?.showroom_name}
                        </h4>
                        <h5
                          style={{
                            color: "#989ead",
                            fontWeight: 400,
                            fontSize: 16,
                          }}
                        >
                          Dealer in {item?.city || "Pakistan"}
                        </h5>
                        <div className="postlocation d-flex align-items-center mb-3">
                          <i className="fa-solid fa-location-dot me-3"></i>
                          <p className="m-0">{item?.showroom_address}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        ) : (
          <div className="No_ads p-3 text-center">
            <p>No Dealers Available</p>
          </div>
        )}

        <div className="d-flex justify-content-center my-4">
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={handlePageChange}
            color="primary"
          />
        </div>
      </div>
    </>
  );
}
